import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logger from '../utils/logger';

export default function ProtectedRoute({ children, requiredRole }) {
  const { user, loading } = useAuth();

  // NOTE: we deliberately do NOT short-circuit on location.state?.user.
  // That state is set during the OAuth callback navigation and would
  // remain stale after logout — causing the user to stay on the dashboard
  // even after auth context is cleared. Always trust live `user` from
  // AuthContext.

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAF8]">
        <div className="w-10 h-10 border-4 border-[#1A1B1E] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!user) {
    logger.warn('ProtectedRoute.unauthenticated_redirect', { path: window.location.pathname });
    return <Navigate to="/" replace />;
  }

  if (user.email_verified === false && user.auth_provider === 'email') {
    logger.warn('ProtectedRoute.unverified_email_redirect', { userId: user.user_id });
    return <Navigate to="/login?verify=pending" replace />;
  }

  if (user.mfa_required) {
    logger.warn('ProtectedRoute.mfa_required_redirect', { userId: user.user_id });
    return <Navigate to="/login?mfa=1" replace />;
  }

  if (requiredRole && user.role !== requiredRole && user.role !== 'admin' && user.role !== 'super_admin') {
    logger.warn('ProtectedRoute.role_mismatch_redirect', { userId: user.user_id, role: user.role, requiredRole });
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
